<template>
  <div
    class="seckill-bar"
    v-if="isBefore || isStart"
    :class="{ before: isBefore, start: isStart, end: isEnd }"
  >
    <div class="seckill-l">
      <div class="prom-price">
        <small>&yen;</small>{{ seckillData.promPrice / 100 }}
      </div>
      <div class="present-price">
        <i class="seckill-mark"></i>
        <span class="price">&yen;{{ seckillData.originalPrice / 100 }}</span>
      </div>
    </div>
    <div class="seckill-r">
      <div v-if="isDefault">{{ formateTime(startTime) }}</div>
      <div class="countdown" v-if="isBefore || isStart">
        <div class="countdown-title">
          {{ isBefore ? `距开始:` : '距结束:' }}
        </div>
        <div class="countdown-timer">
          <span class="timer-item" v-if="time.d">{{ time.d }}</span>
          <i class="timer-split" v-if="time.d">天</i>
          <span class="timer-item">{{ time.h }}</span>
          <i class="timer-split">:</i>
          <span class="timer-item">{{ time.m }}</span>
          <i class="timer-split">:</i>
          <span class="timer-item">{{ time.s }}</span>
        </div>
      </div>
      <div v-if="isEnd">已结束</div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
export default {
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDefault: false,
      isBefore: false,
      isStart: false,
      isEnd: false,
      time: {
        d: "",
        h: "",
        m: "",
        s: "",
      },
      timer: null,
      nowTime: "",
    };
  },
  mounted() {
    this.nowTime = this.seckillData.serviceTime || new Date().getTime();
    this.countDown(
      (remain) => {
        remain && this.splitTime(remain);
      },
      (remain) => {
        remain && this.splitTime(remain);
      }
    );
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    countDown(cbCount, cbFin) {
      this.timer = setInterval(() => {
        const nowTime = this.nowTime;
        const timeDiff = this.startTime - nowTime;
        let remain = 0;

        if (this.startTime && timeDiff > 86400000) {
          this.isDefault = true;
        }
        if (this.startTime && timeDiff > 0 && timeDiff <= 86400000) {
          this.isDefault = false;
          this.isBefore = true;
          remain = (this.startTime - nowTime) / 1000;
          cbCount(remain);
        }
        if (timeDiff <= 0 && this.endTime > nowTime) {
          this.isDefault = false;
          this.isBefore = false;
          this.isStart = true;
          remain = (this.endTime - nowTime) / 1000;
          cbCount(remain);
        }
        if (timeDiff <= 0 && this.endTime <= nowTime) {
          clearInterval(this.timer);
          this.isDefault = false;
          this.isBefore = false;
          this.isStart = false;
          this.isEnd = true;
          cbFin(remain);
        }
        this.nowTime = new Date().getTime() + this.timeOffset;
      }, 1000);
    },
    splitTime(remain) {
      const t = this.time;
      t.d = parseInt(remain / (60 * 60 * 24), 10);
      t.h = `0${parseInt((remain % (60 * 60 * 24)) / (60 * 60))}`.substr(-2);
      t.m = `0${parseInt((remain % (60 * 60)) / 60)}`.substr(-2);
      t.s = `0${parseInt(remain % 60)}`.substr(-2);
    },
    formateTime(time) {
      if (!time) {
        return "";
      }
      const weekday = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      const d = new Date(time);
      const w = weekday[d.getDay()];
      const h = d.getHours() > 9 ? d.getHours() : `0${d.getHours()}`;
      const m = d.getMinutes() > 9 ? d.getMinutes() : `0${d.getMinutes()}`;
      return `${w} ${h}:${m} 准时开抢`;
    },
    getTime(time) {
      const ts =
        typeof time === "string" ? time.toString().replace(/-/g, "/") : time;
      const t = ts && new Date(ts).getTime();
      return t;
    },
  },
  computed: {
    seckillData() {
      return this.product.ruleDetail;
    },
    serviceTime() {
      const nt = new Date().getTime();
      const st = this.seckillData.serviceTime || nt;
      return st;
    },
    startTime() {
      const ts = this.seckillData.startTimeStr;
      const ft = this.getTime(ts);
      return ft;
    },
    endTime() {
      const ts = this.seckillData.endTimeStr;
      const ft = this.getTime(ts);
      return ft;
    },
    timeOffset() {
      const nt = new Date().getTime();

      return this.serviceTime - nt;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/mixin";
.seckill-bar {
  background: #fc6ea2;
  height: rem(100px);
  display: flex;
  align-items: center;
  color: #fff;

  .seckill-l {
    flex: 1;
    padding-left: rem(30px);
  }
  .seckill-r {
    width: rem(260px);
    background: #ffe3e3;
    font-size: rem(28px);
    height: 100%;
    // padding: 0 rem(25px);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .prom-price {
    font-size: rem(42px);
    small {
      font-size: rem(24px);
    }
  }
  .present-price {
    display: flex;
    align-items: center;
    margin-top: rem(6px);
    .price {
      text-decoration: line-through;
      font-size: rem(24px);
    }
  }
  .seckill-mark {
    display: block;
    width: rem(93px);
    height: rem(28px);
    background-image: url("../../assets/images/secondKill@2x.png");
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: rem(16px);
  }

  .countdown {
    // min-width: rem(160px);
  }

  .countdown-title {
    font-size: rem(24px);
    color: #fc6ea2;
  }
  .countdown-timer {
    margin-top: rem(6px);
    font-size: 0;
  }
  .timer-item,
  .timer-split {
    display: inline-block;
    height: rem(48px);
    line-height: rem(48px);
    vertical-align: top;
    font-size: rem(28px);
  }
  .timer-item {
    border-radius: rem(8px);
    background-color: #fc6ea2;
    // padding-left:rem(2px);
    // padding-right: rem(2px);
    min-width: rem(40px);
    text-align: center;
  }
  .timer-split {
    color: #fc6ea2;
    margin: 0 rem(6px);
  }

  &.before {
    .seckill-r {
      background-color: #ccc;
    }
  }

  &.start {
    background-color: #fc6ea2;
    .seckill-mark {
      // background-image: url("~assets/images/courses/seckill_mark_2.png");
    }
    .seckill-r {
      background-color: #ffe3e3;
    }
    .countdown-title {
      color: #ff6ea2;
    }

    .timer-item {
      background-color: #fc6ea2;
      border-radius: rem(8px);
      // background-image: linear-gradient(-130deg, #FF7D46 12%, #FF6060 99%);
    }
    .timer-split {
      color: #ff6ea2;
    }
  }
  &.end {
    background-color: #ccc;
    .seckill-mark {
      // background-image: url("~assets/images/courses/seckill_mark_3.png");
    }
  }
}
</style>
